/**
 * @classdesc Russian Language Pack
 * @desc This class will used to translate tokens into the Russian language.
 * @namespace Languages.Russian
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Russian
 */
export const dictionary = {
    'years'   : 'лет',
    'months'  : 'месяцев',
    'days'    : 'дней',
    'hours'   : 'часов',
    'minutes' : 'минут',
    'seconds' : 'секунд'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Russian
 */
export const aliases = ['ru', 'ru-ru', 'russian'];
